
// Vue
import {Options, Vue} from "vue-class-component";

// Models
import {AppAdministratorOrganizationsRootListFormRemove} from "@/models/app/administrator/organizations/root/list/form/remove";
import {ResponseIndex} from "@/models/response";

// Components
import {
  ElDialog,
  ElForm,
  ElFormItem,
  ElButton,
} from "element-plus";
import {Delete} from "@element-plus/icons-vue";

// Services
import {postRequest} from "@/services/api/request";

@Options({
  props: [
    "organization",
    "isRemoveOrganizationDisabled",
  ],
  components: {
    ElDialog,
    ElForm,
    ElFormItem,
    ElButton,
    Delete,
  },
})
export default class AppAdministratorOrganizationsRootListFormRemoveIndexVue extends Vue {
  isLoading: boolean | null = false;
  isDialogVisible: boolean | null = false;
  isRemoveOrganizationDisabled: boolean | null = false;

  organization: AppAdministratorOrganizationsRootListFormRemove = new AppAdministratorOrganizationsRootListFormRemove();

  formData: AppAdministratorOrganizationsRootListFormRemove = new AppAdministratorOrganizationsRootListFormRemove();

  $refs!: {
    formComponent: HTMLFormElement;
  };

  validateForm(): void {
    this.$refs.formComponent.validate((response: any) => {
      if (response) {
        this.submitForm();
      }
    });
  }

  async submitForm(): Promise<void> {
    this.isLoading = true;
    await postRequest({
      uri: "/administration/organization/remove",
      formData: this.formData,
      isProtected: true,
      isSuccessNotificationVisible: true,
      isErrorNotificationVisible: true,
    }).then((r: ResponseIndex) => {
      if (r.status === "success") {
        this.$emit('getUserOrganizationsForAdministration');
        this.isDialogVisible = false;
        this.resetFormData();
      }
    });
    this.isLoading = false;
  }

  setFormData(): void {
    this.formData = this.organization;
  }

  resetFormData(): void {
    this.formData = new AppAdministratorOrganizationsRootListFormRemove();
  }

  updated(): void {
    this.setFormData();
  }
}
